<template>
  <div>
    <div>
      <el-form v-if="form" :model="form" ref="form" label-width="70px" :hide-required-asterisk="true">
        <div>
          <el-form-item label-width="210px" label="是否设置乐器摆件指引可调角度" prop="isDisplayAdjust" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
            <el-radio-group v-model="form.isDisplayAdjust">
              <el-radio v-for="(item,key) in $enums.boolean" :key="key" :label="Number(key)">{{item}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label-width="210px" label="上传乐器摆件指引图片" prop="displayImageUrl" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
            <el-input class="none" type="text" v-model="form.displayImageUrl" :maxlength="1024"></el-input>
            <div v-if="form.displayImageUrl">
              <el-image :src="form.displayImageUrl2" :preview-src-list="[form.displayImageUrl2]" class="border" style="height: 100px;margin-top: 10px;"></el-image>
            </div>
            <el-upload class="inline-block" style="margin-top: 10px;" action="" :http-request="uploadOSS" :show-file-list="false" accept=".png,.jpg">
              <el-button type="default" style="color: #1890FF;margin-left: 0px;">上传图片</el-button>
            </el-upload>
            <p>说明：仅支持png格式图片文件，且文件大小小于2MB</p>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="text-right">
      <el-button size="medium" @click="$emit('close', form)">取消</el-button>
      <el-button size="medium" type="primary" @click="save()" style="margin-right: 0px;">确定</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'specialty-read-edit',
  components: {},
  props: ['row'],
  data () {
    return {
      form: null
    }
  },
  async created () {
    await this.initForm()
  },
  async mounted () {
  },
  async beforeDestroy () {
    this.$refs["form"].resetFields();
  },
  computed: {},
  watch: {},
  methods: {
    async uploadOSS (event) {
      try {
        if (event.file.size > 1024 * 1024 * 2) {
          throw new Error('仅支持PNG格式图片文件，且文件大小小于2MB')
        }
        // debugger
        this.form.displayImageUrl = await this.$HTTP.ApiOss.uploadOSS(event.file, 'logo', '.png', 'public-read')
        // this.form.displayImageUrl2 = await this.$HTTP.ApiOss.signatureUrl(this.form.displayImageUrl, 'public-read')
        this.form.displayImageUrl2 = this.form.displayImageUrl
        this.$forceUpdate()
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async initForm () {
      if (!this.Tool.isNull(this.row)) {
        // debugger
        this.form = this.row
        this.form.displayImageUrl2 = this.form.displayImageUrl
      } else {
      }
      this.$nextTick(() => {
        if (this.$refs['form']) {
          this.$refs['form'].clearValidate()
        }
      })
    },
    async save () {
      try {
        let isOK = await this.Tool.checkForm(this.$refs['form'])
        if (isOK) {
          let queryParam = {
            isDisplayAdjust: this.form.isDisplayAdjust,
            displayImageUrl: this.form.displayImageUrl,
            specialtyId: this.form.specialtyId
          }
          await this.$HTTP.ApiSpecialty.edit(queryParam)
          this.$message({ type: 'success', message: '操作成功' })
          this.$emit('close', this.form)
        }
      } catch (e) {
        this.Tool.doError(e)
      }
    }
  }
}
</script>
